<template>
    <div class="apply-filter">
       <div style="margin: 0 auto;">
            <div class="top-nav">
            <roof-search v-model="showTypeFilter"  @searchInputChange="searchInputChange" :showApp="false" :showNewIcon="2" :middleContent="false" :showType="true"></roof-search>

            <div class="top-img">
                <img  src="@/assets/img/banner@2x.png" alt="">
            </div>
        </div>
        <div class="list-main">
            <div class="main-content">
                <van-collapse v-model="activeNames" @change="handleChange(index)" accordion v-for="(item,index) in applyCategory" :key="item.id">
                    <van-collapse-item :name="index">
                        <template #title>
                            <div>
                                <span class="span-img"><img class="icon-img" :src="src + item.img" alt=""></span>
                                <span class="fr" style="color:#666666;">{{ item.title }}</span>
                            </div>
                        </template>
                        <div  class="last-p">
                            <p v-for="ite in secondApply" :key="ite.id" class="list-p" @click="handleSecondScreen(ite.id,ite.title)">
                                <span>{{ ite.title }}</span>
                                <span><i class="iconfont icon-youjiantou"></i></span>
                            </p>
                        </div>
                       
                    </van-collapse-item>
                </van-collapse>
                <!-- <van-collapse v-model="activeNames" class="bgc" @change="handleChange(1)" accordion>
                    <van-collapse-item name="1">
                        <template #title>
                            <div>
                                <span>这是图片</span>
                                <span class="fr">标题</span>
                            </div>
                        </template>
                        <p><span>内容</span><span class="fr">＞</span></p>
                        <p>内容</p>
                        <p>内容</p>
                    </van-collapse-item>
                </van-collapse> -->
            </div>
        </div>

       </div>
    </div>
</template>

<script>
import { newProductCategory } from '@/api/centrifuge'
import roofSearch from './roof-search'

export default {
    data () {
        return {
            showTypeFilter:　false,
            activeNames: [], //  默认展开的列表
            applyCategory: [], // 列表数据
            secondApply: [], // 二级数据列表
            src:　'http://cdn.juplus.cn/'
        }
    },
    components: {
        roofSearch
    },
    created () {
        this.newProductCategoryPort()
    },
    methods: {
        selectType () {
            this.$emit('input', false)
        },
        // 一级筛选
        handleChange (activeNames) {
            // console.log(activeNames);
            const newData = this.applyCategory.map((item,index) => {
                    // debugger
                    if (index === activeNames) {
                        return item.children
                    }else {
                        return ''
                    }
                })
                setTimeout(() => {
                    this.secondApply = newData[activeNames]
                },220)
                
                // console.log('获取二级菜单', this.secondApply);
        },
        // 二级筛选
        handleSecondScreen (id, name) {
            // console.log('二级', name, id);
            this.selectType()
            this.$emit('typeIdChange', id)
            // this.$router.push({
            //     name: 'newCentrif',
            //     query: {
            //         id
            //     }
            // })
        },
        // 搜索框发生变化   
        searchInputChange (val) {
            console.log(val);
            // this.requestParams.page = 1
            // this.requestParams.type_id = ''
            // this.requestParams.search = val
            // this.productList = []
            // this.getNewProductListPort()
        },
        // 获取全部类别
        newProductCategoryPort () {
            newProductCategory().then(res => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.applyCategory = data
                    // console.log('获取全部类别', data)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.fr {
    float: right;
}
.apply-filter{
    background-color: #f7f8fb;
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    // background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    .top-nav{
        // display: flex;
        .item{
            height: rem(47);
            background: #81C5DA;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: rem(12);
            &:nth-child(1){
                width: 30%;
            }
            &:nth-child(2){
                width: 35%;
            }
            &:nth-child(3){
                width: 35%;
            }
        }
    }
    .top-img {
        width: 100%;
        // height: rem(240);
        padding-top: rem(46);
        img {
            width: 100%;
            height: 100%;

        }
    }
    .main-content {
        // height: 101%;
        // padding: rem(10);
        .span-img {
            // display: inline-block;
            // width: rem(60);
            // height: rem(60);
            // margin-top: rem(17);
            // border-radius: 30px;
            // background-color: #6CC4DA;
        }
        .icon-img {
            width: rem(51);
            height: rem(51);
            margin-top: rem(17);
            margin-left: rem(15);
            border-radius: 30px;
        }
        /deep/.van-cell__right-icon {
            margin-right: 15px;
        }
        /deep/.van-collapse-item {
            // height: 109px;
            line-height: rem(109);
        }
        /deep/.van-cell__right-icon {
            line-height: rem(80);
            // margin-top: rem(26);
        }
        /deep/.van-cell--clickable {
            height: rem(109);
            line-height: rem(86);
        }
        /deep/.van-cell {
            background-color:transparent;
            background: url(../../../assets/img/bgc.png) no-repeat 50%;
            background-size: cover;
        }
        /deep/.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
            border: none;
        }
        /deep/.van-collapse-item__content {
            padding: rem(12) rem(12);
            background-color:transparent;
        }
    }
    .bgc {
        // background: url(../../../assets/img/bgc.png) no-repeat center center;
    }
}
.list-main {
    // margin-top: rem(239);
    // height: 101%;
    padding: rem(10);
    padding-bottom: rem(75);
    background-color: #f7f8fb;
    .list-p {
        display: flex;
        justify-content: space-between;
        height: 37px;
        line-height: 37px;
        color: #333333;
        border-bottom: 1px solid #F5F5F5;
    }
    .last-p {
        padding: rem(10) rem(15);
        background-color: #fff;
        .list-p:last-of-type {
            border: none;
        }
    }
}
</style>
